export const gameStarted = {
  event: "Game Started",
  properties: {
    type: "Type",
    difficulty: "Difficulty",
    context: "Context",
    games: "Games",
    instruments: "Instruments",
    techniques: "Techniques",
    mixPuzzleSlug: "Mix Puzzle Slug",
  },
};

export const questionAnswered = {
  event: "Question Answered",
  properties: {
    correct: "Correct",
    type: "Type",
  },
};
